module.exports = __webpack_public_path__ + "static/media/11.99385a41.jpg";